import Header from "../../components/Header";
import ContentWrapper from "../../components/ContentWrapper";
import BoxSignsCircular from "./_components/BoxSignsCircular";

const SignsCircular = () => (
  <>
    <div className="px-[10px] pt-[5px]">
      <Header />
    </div>
    <ContentWrapper>
      <BoxSignsCircular />
    </ContentWrapper>
  </>
);

export default SignsCircular;
